<div class="row no-gutter">
    <div class="col-3 d-flex flex-row">
        <img
            class="d-md-none d-flex menu-badge"
            src="assets/img/flume_badge.png"
            alt="water droplet logo"
            (click)="goToCurrent()"
        />
        <img
            class="d-none d-md-flex menu-logo"
            src="assets/img/flume_logo_primary.png"
            alt="water droplet logo with text"
            (click)="goToCurrent()"
        />
    </div>
    <div class="col-9 pr-0 d-flex flex-row justify-content-end">
        <div class="d-none d-md-flex">
            <ng-template [ngIf]="showSelector$">
                <nb-actions>
                    <nb-action
                        class="location-select"
                        style.cursor="pointer"
                        nbTooltip="Change Location"
                        *ngIf="currentLocation$ | async as loc"
                        (click)="chooseLocation()"
                        >{{loc.name}}</nb-action
                    >
                </nb-actions>
            </ng-template>
        </div>
        <nb-actions>
            <nb-action
                [nbPopover]="notifications"
                nbPopoverPlacement="end"
                nbPopoverTrigger="click"
                icon="bell"
                [badgeText]="unreadNotificationCount ? unreadNotificationCount.toFixed() : null"
                badgeStatus="danger"
            ></nb-action>
            <nb-action
                icon="menu-outline"
                nbContextMenuTrigger="hover"
                [nbContextMenu]="additionalMenuItems"
                nbContextMenuTag="add-menu"
            ></nb-action>
        </nb-actions>
    </div>
</div>

<ng-template #notifications>
    <app-notifications
        (markedRead)="reduceUnreadCount()"
        (clearRead)="resetUnreadCount()"
        (hidePopover)="hidePopover()"
        [unreadNotifications]="unreadNotifications"
        [entitlement]="entitlement"
    ></app-notifications>
</ng-template>
